// ── Color utilities ──────────────────────────────────────────────────────────
// Consolidated from generateSprites.ts and SnakeOverlay.ts

/** Extract R, G, B components from a hex number (e.g. 0xff3300). */
export function hexToRgb(hex: number): [number, number, number] {
  return [(hex >> 16) & 0xff, (hex >> 8) & 0xff, hex & 0xff];
}

/** Return a CSS `rgba(r,g,b,a)` string from a hex number. */
export function rgba(hex: number, a = 1): string {
  const [r, g, b] = hexToRgb(hex);
  return `rgba(${r},${g},${b},${a})`;
}

/** Lighten a color by `pct` (0-100) and return a CSS `rgb(...)` string. */
export function lightenCSS(hex: number, pct: number): string {
  const [r, g, b] = hexToRgb(hex);
  const f = pct / 100;
  return `rgb(${Math.min(255, Math.round(r + (255 - r) * f))},${Math.min(255, Math.round(g + (255 - g) * f))},${Math.min(255, Math.round(b + (255 - b) * f))})`;
}

/** Darken a color by `pct` (0-100) and return a CSS `rgb(...)` string. */
export function darkenCSS(hex: number, pct: number): string {
  const [r, g, b] = hexToRgb(hex);
  const f = 1 - pct / 100;
  return `rgb(${Math.round(r * f)},${Math.round(g * f)},${Math.round(b * f)})`;
}

/** Darken a color by `frac` (0-1) and return a hex number. */
export function darkenHex(hex: number, frac: number): number {
  const r = Math.max(0, Math.round(((hex >> 16) & 0xff) * (1 - frac)));
  const g = Math.max(0, Math.round(((hex >> 8) & 0xff) * (1 - frac)));
  const b = Math.max(0, Math.round((hex & 0xff) * (1 - frac)));
  return (r << 16) | (g << 8) | b;
}

/** Lighten a color by `frac` (0-1) and return a hex number. */
export function lightenHex(hex: number, frac: number): number {
  const r = Math.min(255, Math.round(((hex >> 16) & 0xff) + (255 - ((hex >> 16) & 0xff)) * frac));
  const g = Math.min(255, Math.round(((hex >> 8) & 0xff) + (255 - ((hex >> 8) & 0xff)) * frac));
  const b = Math.min(255, Math.round((hex & 0xff) + (255 - (hex & 0xff)) * frac));
  return (r << 16) | (g << 8) | b;
}
